/* eslint-disable */
import * as d3 from "d3";
import * as ss from "simple-statistics";

import Configuration from "@/utils/configuration";

const API_HOST = Configuration.value("VUE_APP_API_HOST");

let activateCarryTotalButtons;
let activateClubs;
let addToClubsArr;
let bringToTop;
let brush;
let brushWrapper;
let brushended;
let brushstarted;
let carryOrTotal = "totaldistance";
let clip;
let clubType;
let convertRow;
let currClub = "all";
let currStat = "totaldistance";
let currZoom;
let dataHold = [];
let drawClubButtons;
let drawData;
let drawGreenShots;
let drawRegression;
let fillTableData;
let filterByClub;
let filtered_data;
let gClubs = [];
let gRounds = {};
let getOffline;
let greenCurvesWrapper;
let greenDotsWrapper;
let height;
const idleDelay = 350;
let idleTimeout = null;
let idled;
let linData;
let listener;
let loadRounds;
let loadShots;
let make_y_gridlines;
let margin;
let removeShotDetail;
let roundToDecimal;
let scatter;
let scrollable = true;
let sendToBack;
let setStat;
let showShotDetail;
let svg;
let width;
let windowWidth = window.innerWidth;
let x;
let xAxis;
let xExtent;
let y;
let yAxis;
let yExtent;
let zoom;
const indexOf =
  [].indexOf ||
  function(item) {
    for (let i = 0, l = this.length; i < l; i++) {
      if (i in this && this[i] === item) return i;
    }
    return -1;
  };

// window.AA = {}; //* Not sure why it's global
const AA = {};

window.onerror = function(message, source, lineno, colno, error) {
  console.log("ERROR", {
    message,
    source,
    line_number: lineno,
    column_number: colno,
    error
  });
  return true;
};

AA.shotDataAll = [];
const clubsAvailable = [
  {
    key: "1Wood",
    label: "D",
    title: "Driver",
    active: false
  },
  {
    key: "3Wood",
    label: "3W",
    title: "3 Wood",
    active: false
  },
  {
    key: "4Wood",
    label: "4W",
    title: "4 Wood",
    active: false
  },
  {
    key: "5Wood",
    label: "5W",
    title: "5 Wood",
    active: false
  },
  {
    key: "6Wood",
    label: "6W",
    title: "6 Wood",
    active: false
  },
  {
    key: "7Wood",
    label: "7W",
    title: "7 Wood",
    active: false
  },
  {
    key: "2Hybrid",
    label: "2H",
    title: "2 Hybrid",
    active: false
  },
  {
    key: "3Hybrid",
    label: "3H",
    title: "3 Hybrid",
    active: false
  },
  {
    key: "4Hybrid",
    label: "4H",
    title: "4 Hybrid",
    active: false
  },
  {
    key: "5Hybrid",
    label: "5H",
    title: "5 Hybrid",
    active: false
  },
  {
    key: "6Hybrid",
    label: "6H",
    title: "6 Hybrid",
    active: false
  },
  {
    key: "7Hybrid",
    label: "7H",
    title: "7 Hybrid",
    active: false
  },
  {
    key: "1Iron",
    label: "1I",
    title: "1 Iron",
    active: false
  },
  {
    key: "2Iron",
    label: "2I",
    title: "2 Iron",
    active: false
  },
  {
    key: "3Iron",
    label: "3I",
    title: "3 Iron",
    active: false
  },
  {
    key: "4Iron",
    label: "4I",
    title: "4 Iron",
    active: false
  },
  {
    key: "5Iron",
    label: "5I",
    title: "5 Iron",
    active: false
  },
  {
    key: "6Iron",
    label: "6I",
    title: "6 Iron",
    active: false
  },
  {
    key: "7Iron",
    label: "7I",
    title: "7 Iron",
    active: false
  },
  {
    key: "8Iron",
    label: "8I",
    title: "8 Iron",
    active: false
  },
  {
    key: "9Iron",
    label: "9I",
    title: "9 Iron",
    active: false
  },
  {
    key: "PitchingWedge",
    label: "PW",
    title: "Pitching Wedge",
    active: false
  },
  {
    key: "GapWedge",
    label: "GW",
    title: "Gap Wedge",
    active: false
  },
  {
    key: "SandWedge",
    label: "SW",
    title: "Sand Wedge",
    active: false
  },
  {
    key: "LobWedge",
    label: "LW",
    title: "Lob Wedge",
    active: false
  },
  {
    key: "Putter",
    label: "P",
    title: "Putter",
    active: false
  }
];

// document.onkeydown = function(evt) {
//   let isEscape;
//   evt = evt || window.event;
//   isEscape = false;
//   if (indexOf.call(evt, 'key') >= 0) {
//     isEscape = evt.key === 'Escape' || evt.key === 'Esc';
//   } else {
//     isEscape = evt.keyCode === 27;
//   }
//   if (isEscape) {
//     return console.log('esc key pressed');
//   }
// };

const loadInit = (roundID, user) => {
  let token;
  let userId;
  console.log("Advanced Analytics loading...");
  if (
    window.localStorage.getItem("userPreferences") &&
    (userId = JSON.parse(window.localStorage.getItem("userPreferences")).userID)
  ) {
    //* check if token user is same as route user
    AA.userId = userId === user ? userId : user;
  } else {
    console.log("userId not found");
    alert("User not found");
  }
  if ((token = window.localStorage.getItem("token"))) {
    AA.bearerToken = `Bearer ${token}`;
  } else {
    console.log("auth token not found");
    alert("Unable to authenticate");
  }
  d3.selectAll("#rounds-1").on("change", function() {
    return loadShots(d3.select(this).property("value"), 1, user);
  });
  d3.selectAll("#rounds-2").on("change", function() {
    return loadShots(d3.select(this).property("value"), 2, user);
  });
  d3.selectAll(".stat-btn").on("click", function() {
    return setStat(d3.select(d3.event.currentTarget).attr("data-stat"));
  });
  return loadRounds(roundID, user);
};

d3.select(window).on("resize", function() {
  if (window.innerWidth !== windowWidth) {
    windowWidth = window.innerWidth;
    return drawData(AA.shotDataAll);
  }
});

document.addEventListener("touchmove", listener, {
  passive: false
});

loadRounds = (roundID = "", user) => {
  let roundURL = `${API_HOST}/users/${AA.userId}/rounds`;

  if (!AA.userId || !AA.bearerToken) {
    alert("Not authenticated");
    return;
  }

  d3.json(roundURL, {
    headers: new Headers({
      Authorization: `${AA.bearerToken}`
    })
  })
    .then(rounds => {
      let firstClass;
      let selectedClass;
      let index;
      let key;
      let val;

      gRounds = {};
      index = 0;
      for (key in rounds) {
        if ({}.hasOwnProperty.call(rounds, key)) {
          val = rounds[key];
          gRounds[val.id] = val;
          firstClass = index === 0 ? "first" : "";
          selectedClass = val.id === roundID ? "selected-round" : "";

          d3.selectAll(".rounds-selector")
            ?.append("option")
            ?.attr("class", `${firstClass} ${selectedClass}`)
            ?.property("value", val.id)
            ?.text(
              `${val?.courseName} - ${new Date(val?.createdAt).toLocaleDateString(
                "en-US"
              )}`
            );
          index += 1;
        }
      }

      if (roundID) {
        d3.selectAll("#rounds-json")?.property("value", JSON.stringify(rounds));
        d3.selectAll("#rounds-1")
          .selectAll(".selected-round")
          .attr("selected", true);
        return loadShots(d3.selectAll("#rounds-1")?.property("value"), 1, user);
      }

      d3.selectAll("#rounds-json")?.property("value", JSON.stringify(rounds));
      d3.selectAll("#rounds-1")
        .selectAll(".first")
        .attr("selected", true);
      return loadShots(d3.selectAll("#rounds-1")?.property("value"), 1, user);
    })
    .catch(error => {
      throw error;
    });
};

loadShots = (roundId, roundIndex, user) => {
  let j;
  let len;
  let ref;
  let row;
  let url = `${API_HOST}/rounds/${roundId}/shots`;

  console.log("loadShots fired for round: ", roundId, roundIndex);
  if (roundId === "select") {
    if (roundIndex === 1) {
      AA.shotDataAll = AA?.shotDataAll?.filter(function(r) {
        return r.compare === true;
      });
    } else {
      AA.shotDataAll = AA?.shotDataAll?.filter(function(r) {
        return r.compare !== true;
      });
    }
    d3.select("#shots-json").property("value", JSON.stringify(AA?.shotDataAll));
    gClubs = [];
    ref = AA?.shotDataAll;
    for (j = 0, len = ref.length; j < len; j++) {
      row = ref?.[j];
      addToClubsArr(row?.clubTypeKey);
    }
    activateClubs();
    filterByClub("all");
    return;
  }

  return d3
    .json(url, {
      headers: new Headers({
        Authorization: `${AA?.bearerToken}`
      })
    })
    .then(data => {
      let k;
      let l;
      let len1;
      let len2;
      let ref1;
      let trueShotIndex;
      if (!data) {
        throw Error("No Data");
      } else {
        data = data
          ?.filter(function(row) {
            return !row.mulligan;
          })
          ?.filter(item => item?.userID === user);
        trueShotIndex = 1;
        for (k = 0, len1 = data.length; k < len1; k++) {
          row = data?.[k];
          convertRow(row, roundIndex, trueShotIndex);
          trueShotIndex += 1;
        }
        if (AA?.shotDataAll?.length > 0) {
          if (roundIndex === 1) {
            AA.shotDataAll = AA?.shotDataAll?.filter(function(r) {
              return r.compare === true;
            });
          } else {
            AA.shotDataAll = AA?.shotDataAll?.filter(function(r) {
              return r.compare !== true;
            });
          }
          AA.shotDataAll = AA?.shotDataAll?.concat(data);
        } else {
          AA.shotDataAll = data;
        }
        d3.select("#shots-json").property(
          "value",
          JSON.stringify(AA?.shotDataAll)
        );
        gClubs = [];
        ref1 = AA?.shotDataAll;
        for (l = 0, len2 = ref1.length; l < len2; l++) {
          row = ref1?.[l];
          addToClubsArr(row?.clubTypeKey);
        }
        activateClubs();
        filterByClub("all");
        return setStat(currStat);
      }
    })
    .catch(error => {
      throw error;
    });
};

convertRow = (d, roundIndex, trueShotIndex) => {
  let error;
  let spinAxis;
  d.trueShotIndex = trueShotIndex;
  if (roundIndex === 2) {
    d.compare = true;
  }
  d.hole = d?.courseHoleIndex + 1;
  d.ballspeed = Math.round(d.launchBallSpeed / 1.467);
  d.totaldistance = isNaN(d?.totalDistance)
    ? 0 / 0
    : roundToDecimal(d?.totalDistance / 3);
  if (d.clubTypeKey === "Putter") {
    d.rolldistance = isNaN(d?.totalDistance)
      ? 0 / 0
      : roundToDecimal(d?.totalDistance / 3);
    d.distance = 0;
  } else {
    d.distance = isNaN(d?.carryDistance)
      ? 0 / 0
      : roundToDecimal(d?.carryDistance / 3);
    d.rolldistance =
      isNaN(d.carryDistance) || isNaN(d?.totalDistance)
        ? 0 / 0
        : roundToDecimal(d?.totalDistance - d?.carryDistance);
  }
  d.hla = roundToDecimal(d?.launchDirection);
  d.vla = roundToDecimal(d?.launchAngle);
  d.backspin = isNaN(d?.launchBackSpin) ? 0 / 0 : d?.launchBackSpin;
  d.sidespin = isNaN(d?.launchSideSpin) ? 0 / 0 : d?.launchSideSpin;
  d.totalspin =
    isNaN(d?.launchBackSpin) || isNaN(d?.launchSideSpin)
      ? 0 / 0
      : Math.round(
          Math.sqrt(
            Math.pow(+d?.launchBackSpin, 2) + Math.pow(d?.launchSideSpin, 2)
          )
        );
  if (d.clubTypeKey === "Putter") {
    d.spinaxis = 0;
    d.flighttime = 0;
    d.height = 0;
  } else {
    spinAxis =
      isNaN(d?.launchBackSpin) || isNaN(d?.launchSideSpin)
        ? 0 / 0
        : parseInt(
            Math.round(
              Math.atan(d?.launchSideSpin / d?.launchBackSpin) * (180 / Math.PI)
            ).toFixed(0)
          );
    d.spinaxis = isNaN(spinAxis) ? 0 / 0 : spinAxis;
    d.height = (function() {
      try {
        return Math.round(
          d?.snapshots?.filter(function(s) {
            return s?.type === "apex";
          })?.[0]?.height / 3
        );
      } catch (error1) {
        error = error1;
        return 0 / 0;
      }
    })();
    d.flighttime = (function() {
      try {
        return (
          Math.round(
            (d.snapshots.filter(function(s) {
              return s?.type === "carry";
            })?.[0]?.milliseconds /
              1000) *
              10
          ) / 10
        );
      } catch (error1) {
        error = error1;
        return 0 / 0;
      }
    })();
  }
  d.clubspeed = d?.clubHeadSpeed ? Math.round(d?.clubHeadSpeed / 1.467) : 0 / 0;
  d.smash =
    d.clubHeadSpeed !== 0 && !isNaN(d?.clubHeadSpeed)
      ? d?.launchBallSpeed / d?.clubHeadSpeed
      : 0 / 0;
  d.topin = (function() {
    try {
      return Math.round(
        d?.snapshots?.filter(function(s) {
          return s?.type === "total";
        })?.[0]?.pinDistance / 3
      );
    } catch (error1) {
      error = error1;
      return 0 / 0;
    }
  })();
  d.startX = (function() {
    try {
      return d?.snapshots?.filter(function(s) {
        return s?.type === "launch";
      })?.[0]?.position?.x;
    } catch (error1) {
      error = error1;
      return 0 / 0;
    }
  })();
  d.startY = (function() {
    try {
      return d?.snapshots?.filter(function(s) {
        return s?.type === "launch";
      })?.[0]?.position?.y;
    } catch (error1) {
      error = error1;
      return 0 / 0;
    }
  })();
  d.carryX = (function() {
    try {
      if (d?.clubTypeKey === "Putter") {
        return d?.snapshots?.filter(function(s) {
          return s?.type === "carry";
        })?.[0]?.position?.x;
      }
      return d?.snapshots?.filter(function(s) {
        return s?.type === "total";
      })?.[0]?.position?.x;
    } catch (error1) {
      error = error1;
      return 0 / 0;
    }
  })();
  d.carryY = (function() {
    try {
      if (d?.clubTypeKey === "Putter") {
        return d?.snapshots?.filter(function(s) {
          return s?.type === "carry";
        })?.[0]?.position?.y;
      }
      return d?.snapshots?.filter(function(s) {
        return s?.type === "total";
      })?.[0]?.position?.y;
    } catch (error1) {
      error = error1;
      return 0 / 0;
    }
  })();
  d.totalX = (function() {
    try {
      return d?.snapshots?.filter(function(s) {
        return s?.type === "total";
      })?.[0]?.position?.x;
    } catch (error1) {
      error = error1;
      return 0 / 0;
    }
  })();
  d.totalY = (function() {
    try {
      return d?.snapshots?.filter(function(s) {
        return s?.type === "total";
      })?.[0]?.position?.y;
    } catch (error1) {
      error = error1;
      return 0 / 0;
    }
  })();
  d.faceangle = isNaN(d?.clubFaceAngle) ? 0 / 0 : d?.clubFaceAngle;
  d.swingpath = isNaN(d?.clubPathAngle) ? 0 / 0 : d?.clubPathAngle;
  return d;
};

roundToDecimal = (num, decimal) => {
  if (decimal == null) {
    decimal = 1;
  }
  if (isNaN(num)) {
    return 0 / 0;
  }
  return Math.round(num * 10 * decimal) / (10 * decimal);
};

addToClubsArr = clubTypeKey => {
  if (gClubs.indexOf(clubTypeKey) === -1) {
    return gClubs.push(clubTypeKey);
  }
};

activateClubs = () => {
  let availClub;
  let club;
  let j;
  let k;
  let l;
  let len;
  let len1;
  let len2;
  for (j = 0, len = clubsAvailable.length; j < len; j++) {
    club = clubsAvailable[j];
    club.active = false;
  }
  for (k = 0, len1 = gClubs.length; k < len1; k++) {
    club = gClubs[k];
    for (l = 0, len2 = clubsAvailable.length; l < len2; l++) {
      availClub = clubsAvailable[l];
      if (club === availClub?.key) {
        availClub.active = true;
      }
    }
  }
  return drawClubButtons();
};

activateCarryTotalButtons = () => {
  d3.select("#carry-btn").on("click", function() {
    carryOrTotal = "distance";
    d3.selectAll(".carry-total-buttons button").classed("active", false);
    d3.select(this).classed("active", true);
    return drawGreenShots(dataHold);
  });
  return d3.select("#total-btn").on("click", function() {
    carryOrTotal = "totaldistance";
    d3.selectAll(".carry-total-buttons button").classed("active", false);
    d3.select(this).classed("active", true);
    return drawGreenShots(dataHold);
  });
};

setStat = stat => {
  let data;
  d3.selectAll(".stat-btn").classed("active", false);
  d3.select(`#${stat}-btn`).classed("active", true);
  currStat = stat;
  if (currClub === "all") {
    data = AA?.shotDataAll;
  } else {
    data = AA?.shotDataAll?.filter(function(row) {
      return currClub === row?.clubTypeKey;
    });
  }
  drawData(data);
  if (currZoom) {
    x.domain(currZoom.map(x.invert, x)).nice();
    return zoom(0, data);
  }
};

bringToTop = els =>
  els.each(function(index) {
    return d3
      .select(this.parentNode)
      .node()
      .append(function() {
        return d3.selectAll(this);
      });
  });

sendToBack = els =>
  els.each(function(index) {
    return d3
      .select(this.parentNode)
      .node()
      .prepend(function() {
        return d3.selectAll(this);
      });
  });

clubType = d => {
  d.club = d.club;
  d.shotcount = +d.shotcount;
  return d;
};

drawClubButtons = () => {
  let activeClass;
  let activeClubs;
  let club;
  let clubCount;
  let j;
  let len;
  d3.select("#club-buttons").html("");
  activeClubs = clubsAvailable.filter(function(c) {
    return c.active === true;
  });
  clubCount = activeClubs.length;
  if (clubCount > 1) {
    d3.select("#club-buttons")
      .append("button")
      .attr("class", "club-selector active")
      .attr("id", "club-all")
      .attr("data-club-key", "all")
      .attr("title", "All club shots")
      .text("All");
  }
  for (j = 0, len = activeClubs.length; j < len; j++) {
    club = activeClubs[j];
    activeClass = clubCount === 1 ? " active" : "";
    d3.select("#club-buttons")
      .append("button")
      .attr("class", `club-selector${activeClass}`)
      .attr("id", `club-${club.key}`)
      .attr("data-club-key", club.key)
      .attr("title", `${club.title} shots`)
      .text(club.label);
  }
  return d3.selectAll(".club-selector").each(function() {
    let buttonClub;
    buttonClub = d3.select(this).attr("data-club-key");
    return d3.select(this).on("click", function() {
      return filterByClub(buttonClub);
    });
  });
};

filterByClub = club => {
  let clubData;
  if (currClub === club) {
    return;
  }
  currClub = club;
  d3.selectAll(".club-selector").classed("active", false);
  d3.select(`#club-${club}`).classed("active", true);
  if (club === "all") {
    return drawData(AA.shotDataAll);
  }
  clubData = AA.shotDataAll.filter(function(row) {
    return club === row.clubTypeKey;
  });
  return drawData(clubData);
};

make_y_gridlines = () => d3.axisLeft(y).ticks(5);

drawData = data => {
  const d3ChartNodeCheck = d3.select("#chart").node();
  if (d3ChartNodeCheck === null) return;

  let xRange;
  let yDiff;
  let yMax;
  let yMin;
  d3.select(".brush").on("touchmove", listener, {
    passive: false
  });
  windowWidth = window.innerWidth;
  activateCarryTotalButtons();
  margin = {
    top: 0,
    right: -1,
    bottom: 23,
    left: -1
  };
  width =
    d3
      .select("#chart")
      .node()
      .getBoundingClientRect().width -
    margin.left -
    margin.right;
  height =
    d3
      .select("#chart")
      .node()
      .getBoundingClientRect().height -
    margin.top -
    margin.bottom;
  x = d3.scaleLinear().range([0, width]);
  y = d3.scaleLinear().range([height, 0]);
  xAxis = d3
    .axisBottom(x)
    .tickSizeOuter(0)
    .ticks(18)
    .tickFormat(function(d) {
      if (parseInt(d) === d) {
        return d;
      }
      return "";
    });
  yAxis = d3
    .axisLeft(y)
    .ticks(5)
    .tickSizeOuter(0)
    .tickSize(-width);
  brush = d3
    .brush()
    .extent([
      [0, 0],
      [width, height]
    ])
    .on("start", brushstarted)
    .on("end", brushended);
  d3.select("#chart").html("");
  if (!data) {
    return;
  }
  data = data.filter(function(d) {
    return !isNaN(d[currStat]);
  });
  svg = d3
    .select("#chart")
    .append("svg")
    .attr("width", width + margin.left + margin.right)
    .attr("height", height + margin.top + margin.bottom)
    .append("g")
    .attr("transform", `translate(${margin.left},${margin.top})`)
    .attr("class", "chart-area");
  clip = svg
    .append("defs")
    .append("svg:clipPath")
    .attr("id", "clip")
    .append("svg:rect")
    .attr("width", width)
    .attr("height", height)
    .attr("x", 0)
    .attr("y", 0);
  brushWrapper = svg
    .append("g")
    .attr("id", "brush-wrapper")
    .attr("clip-path", "url(#clip)");
  scatter = svg
    .append("g")
    .attr("id", "scatterplot")
    .attr("clip-path", "url(#clip)");
  dataHold = data;
  drawGreenShots(data);
  xExtent = [1, 18];
  xRange = xExtent?.[1] - xExtent?.[0];
  x.domain([xExtent?.[0] - xRange * 0.05, xExtent?.[1] + xRange * 0.05]);
  if (data.length === 1) {
    yMin = data?.[0][currStat] - 2;
    yMax = data?.[0][currStat] + 2;
    y.domain([yMin, yMax]);
  } else {
    yMin = d3.min(data, function(d) {
      return d[currStat];
    });
    yMax = d3.max(data, function(d) {
      return d[currStat];
    });
    yDiff = yMax - yMin;
    y.domain([yMin - yDiff * 0.1, yMax + yDiff * 0.1]);
  }
  svg
    .append("g")
    .attr("class", "x axis")
    .attr("id", "axis--x")
    .attr("transform", `translate(0,${height})`)
    .call(xAxis);
  svg
    .append("g")
    .attr("class", "y axis")
    .attr("id", "axis--y")
    .call(yAxis)
    .selectAll(".tick text")
    .attr("dx", 8)
    .attr("dy", -3);
  svg
    .append("g")
    .attr("class", "grid")
    .call(
      make_y_gridlines()
        .tickSize(-width)
        .tickFormat("")
    );
  svg.append("path").attr("class", "regression");
  brushWrapper
    .append("g")
    .attr("class", "brush")
    .call(brush);
  scatter
    .selectAll(".dot")
    .data(data)
    .enter()
    .append("circle")
    .attr("class", function(d) {
      return `dot s${d.id}${d.compare === true ? " comp" : ""}`;
    })
    .attr("r", 5)
    .attr("cx", function(d) {
      return x(d.hole);
    })
    .attr("cy", function(d) {
      if (isNaN(d[currStat])) {
        return y(-10000);
      }
      return y(d[currStat]);
    })
    .on("click", function(d) {
      return showShotDetail(d);
    })
    .on("mouseover", function(d) {
      return d3.selectAll(`.s${d.id}`).classed("hover", true);
    })
    .on("mouseout", function(d) {
      return d3.selectAll(`.s${d.id}`).classed("hover", false);
    });
  return fillTableData();
};

removeShotDetail = () => {
  d3.selectAll("tr.detail")
    .classed("main", false)
    .classed("compare", false)
    .selectAll("th, td")
    .html(" - ");
  return d3.selectAll(".dot").classed("active", false);
};

showShotDetail = s => {
  let club;
  d3.selectAll(".dot, .top-dot, .curve").classed("active", false);
  d3.selectAll(`.s${s.id}`).classed("active", true);
  bringToTop(d3.selectAll(`.s${s.id}`));
  if (s.compare === true) {
    d3.selectAll("tr.detail")
      .classed("main", false)
      .classed("compare", true);
  } else {
    d3.selectAll("tr.detail")
      .classed("main", true)
      .classed("compare", false);
  }
  club = clubsAvailable?.filter(function(c) {
    return c.key === s.clubTypeKey;
  })[0]?.title;
  d3.select("#detail-header").html(`Shot ${s.trueShotIndex} (${club})`);
  [
    "ballspeed",
    "distance",
    "rolldistance",
    "totaldistance",
    "backspin",
    "height",
    "sidespin",
    "totalspin",
    "spinaxis",
    "clubspeed"
  ].forEach(function(m) {
    let val;
    val = Math.round(s[m]);
    return d3
      .select(`#detail-${m}`)
      .html(isNaN(val) ? "-" : val.toLocaleString());
  });
  ["topin"].forEach(function(m) {
    let val;
    val = s[m];
    if (isNaN(val)) {
      return d3.select(`#detail-${m}`).html("-");
    }
    if (val < 20) {
      val = Math.round(s[m] * 3);
      return d3.select(`#detail-${m}`).html(`${val.toLocaleString()} ft`);
    }
    val = Math.round(s[m]);
    return d3.select(`#detail-${m}`).html(`${val.toLocaleString()} yds`);
  });
  ["hla", "vla", "flighttime", "swingpath", "faceangle"].forEach(function(m) {
    let val;
    val = s[m];
    return d3.select(`#detail-${m}`).html(isNaN(val) ? "-" : val.toFixed(1));
  });
  return ["smash"].forEach(function(m) {
    let val;
    val = s[m];
    return d3.select(`#detail-${m}`).html(isNaN(val) ? "-" : val.toFixed(1));
  });
};

drawRegression = filtered_data => {
  let err;
  let lin;
  let lindata;
  let line;
  let regressionData;

  // if (!filtered_data.length) {
  //   d3.selectAll('.regression').classed('hide', true);
  // }
  // filtered_data = filtered_data.filter(function(d) {
  //   return !isNaN(d[currStat]);
  // });
  // if (
  //   !filtered_data.length ||
  //   d3.min(filtered_data, function(d) {
  //     return d.hole;
  //   }) ===
  //     d3.max(filtered_data, function(d) {
  //       return d.hole;
  //     })
  // ) {
  // } else {
  //   d3.selectAll('.regression').classed('hide', false);
  // }
  // try {
  //   line = d3
  //     .line()
  //     .x(function(d) {
  //       return x(d.hole);
  //     })
  //     .y(function(d) {
  //       return y(d[currStat]);
  //     });
  //   regressionData = ss.linearRegression(
  //     filtered_data.map(function(d) {
  //       return [+d.hole, d[currStat]];
  //     })
  //   );
  //   lin = ss.linearRegressionLine(regressionData);
  //   lindata = x.domain().map(function(x) {
  //     let tmpObj;
  //     tmpObj = {};
  //     tmpObj[currStat] = lin(+x);
  //     tmpObj.hole = x;
  //     return tmpObj;
  //   });
  //   return d3
  //     .select('.regression')
  //     .datum(lindata)
  //     .attr('class', 'regression')
  //     .transition()
  //     .duration(750)
  //     .attr('d', line);
  // } catch (error1) {
  //   err = error1;
  //   return d3.selectAll('.regression').classed('hide', true);
  // }
};

brushstarted = () => {
  scrollable = false;
};

currZoom = false;

brushended = () => {
  let s;
  let xRange;
  scrollable = true;
  s = d3.event.selection;
  if (!s) {
    if (!idleTimeout) {
      return (idleTimeout = setTimeout(idled, idleDelay));
    }
    xExtent = [1, 18];
    xRange = xExtent?.[1] - xExtent?.[0];
    x.domain([xExtent?.[0] - xRange * 0.05, xExtent?.[1] + xRange * 0.05]);
    y.domain(
      d3.extent(AA.shotDataAll, function(d) {
        return d[currStat];
      })
    ).nice();
    currZoom = false;
  } else {
    currZoom = [s?.[0]?.[0], s?.[1]?.[0]];
    x.domain([s?.[0]?.[0], s?.[1]?.[0]].map(x.invert, x)).nice();
    y.domain([s?.[1]?.[1], s?.[0]?.[1]].map(y.invert, y)).nice();
    brushWrapper.select(".brush").call(brush.move, null);
  }
  return zoom(750, fillTableData());
};

idled = () => (idleTimeout = null);

fillTableData = () => {
  let filteredData;
  let visibleEnd;
  let visibleEndY;
  let visibleStart;
  let visibleStartY;
  removeShotDetail();
  d3.selectAll("table#stats td").html("-");
  visibleStart = x.invert(0);
  visibleEnd = x.invert(width);
  visibleStartY = y.invert(height);
  visibleEndY = y.invert(0);
  filteredData = AA.shotDataAll.filter(function(d) {
    if (currClub === "all") {
      return (
        d.hole >= visibleStart &&
        d.hole <= visibleEnd &&
        (isNaN(d[currStat]) ||
          (d[currStat] >= visibleStartY && d[currStat] <= visibleEndY))
      );
    }
    return (
      d.clubTypeKey === currClub &&
      d.hole >= visibleStart &&
      d.hole <= visibleEnd &&
      (isNaN(d[currStat]) ||
        (d[currStat] >= visibleStartY && d[currStat] <= visibleEndY))
    );
  });
  if (currClub === "all") {
    d3.select("#detail-header").html("All Clubs");
  } else {
    d3.select("#detail-header").html(
      clubsAvailable.filter(function(c) {
        return c.key === currClub;
      })?.[0]?.title
    );
  }
  d3.select("#shot-count").html(
    `${filteredData.length}<br>shot${filteredData.length !== 1 ? "s" : ""}`
  );
  if (filteredData.length === 1) {
    d3.selectAll(".dot").classed("active", false);
    d3.selectAll(`.s${filteredData?.[0].id}`).classed("active", true);
    showShotDetail(filteredData?.[0]);
  }
  if (filteredData.length > 0) {
    [
      "ballspeed",
      "distance",
      "rolldistance",
      "totaldistance",
      "backspin",
      "height",
      "sidespin",
      "totalspin",
      "spinaxis",
      "clubspeed"
    ].forEach(function(m, index) {
      let dataToMap;
      dataToMap = filteredData
        .map(function(d) {
          return d[m];
        })
        .filter(function(s) {
          return !isNaN(s);
        });
      if (dataToMap.length > 0) {
        d3.select(`#avg-${m}`).html(
          Math.round(ss.mean(dataToMap)).toLocaleString()
        );
        d3.select(`#min-${m}`).html(
          Math.round(ss.min(dataToMap)).toLocaleString()
        );
        d3.select(`#max-${m}`).html(
          Math.round(ss.max(dataToMap)).toLocaleString()
        );
        return d3
          .select(`#stddev-${m}`)
          .html(Math.round(ss.standardDeviation(dataToMap)).toLocaleString());
      }
    });
    ["topin"].forEach(function(m, index) {
      let convDist;
      let dataToMap;
      let max;
      let mean;
      let min;
      let sd;
      dataToMap = filteredData
        .map(function(d) {
          return d[m];
        })
        .filter(function(s) {
          return !isNaN(s);
        });
      if (dataToMap.length > 0) {
        mean = ss.mean(dataToMap);
        min = ss.min(dataToMap);
        max = ss.max(dataToMap);
        sd = ss.standardDeviation(dataToMap);
        convDist = 20;
        if (mean < convDist) {
          mean *= 3;
          d3.select(`#avg-${m}`).html(
            `${Math.round(mean).toLocaleString()} ft`
          );
        } else {
          d3.select(`#avg-${m}`).html(
            `${Math.round(mean).toLocaleString()} yds`
          );
        }
        if (min < convDist) {
          min *= 3;
          d3.select(`#min-${m}`).html(`${Math.round(min).toLocaleString()} ft`);
        } else {
          d3.select(`#min-${m}`).html(
            `${Math.round(min).toLocaleString()} yds`
          );
        }
        if (max < convDist) {
          max *= 3;
          d3.select(`#max-${m}`).html(`${Math.round(max).toLocaleString()} ft`);
        } else {
          d3.select(`#max-${m}`).html(
            `${Math.round(max).toLocaleString()} yds`
          );
        }
        if (sd < convDist) {
          sd *= 3;
          return d3
            .select(`#stddev-${m}`)
            .html(`${Math.round(sd).toLocaleString()} ft`);
        }
        return d3
          .select(`#stddev-${m}`)
          .html(`${Math.round(sd).toLocaleString()} yds`);
      }
    });
    ["hla", "vla", "flighttime", "swingpath", "faceangle"].forEach(function(
      m,
      index
    ) {
      let dataToMap;
      dataToMap = filteredData
        .map(function(d) {
          return d[m];
        })
        .filter(function(s) {
          return !isNaN(s);
        });
      if (dataToMap.length > 0) {
        d3.select(`#avg-${m}`).html(ss.mean(dataToMap).toFixed(1));
        d3.select(`#min-${m}`).html(ss.min(dataToMap).toFixed(1));
        d3.select(`#max-${m}`).html(ss.max(dataToMap).toFixed(1));
        return d3
          .select(`#stddev-${m}`)
          .html(ss.standardDeviation(dataToMap).toFixed(1));
      }
    });
    ["smash"].forEach(function(m, index) {
      let dataToMap;
      dataToMap = filteredData
        .map(function(d) {
          return d[m];
        })
        .filter(function(s) {
          return !isNaN(s);
        });
      if (dataToMap.length > 0) {
        d3.select(`#avg-${m}`).html(ss.mean(dataToMap).toFixed(2));
        d3.select(`#min-${m}`).html(ss.min(dataToMap).toFixed(2));
        d3.select(`#max-${m}`).html(ss.max(dataToMap).toFixed(2));
        return d3
          .select(`#stddev-${m}`)
          .html(ss.standardDeviation(dataToMap).toFixed(2));
      }
    });
    drawGreenShots(filteredData);
    return filteredData;
  }
  return d3.selectAll("table#stats td").html("");
};

zoom = (transitionDuration, filteredData) => {
  let t;
  t = scatter.transition().duration(transitionDuration);
  svg
    .select("#axis--x")
    .transition(t)
    .call(xAxis);
  svg
    .select("#axis--y")
    .transition(t)
    .call(yAxis)
    .selectAll(".tick text")
    .attr("dx", 8);
    // .attr("dy", -3); // Disabling this...throwing errors for some reason?
  svg
    .select(".grid")
    .transition(t)
    .call(
      make_y_gridlines()
        .tickSize(-width)
        .tickFormat("")
    );
  return scatter
    .selectAll("circle")
    .transition(t)
    .attr("cx", function(d) {
      return x(d.hole);
    })
    .attr("cy", function(d) {
      if (isNaN(d[currStat])) {
        return y(-10000);
      }
      return y(d[currStat]);
    });
};

listener = e => {
  if (!scrollable) {
    e.preventDefault();
  }
};

drawGreenShots = data => {
  let arc;
  let arcColorArray = [];
  let arcColorArrayIndex = 0;
  let distanceArr = [];
  let greenHeight = 0;
  let greenSvg;
  let greenWidth = 0;
  let halfcircle = 0;
  let heightAdj = 0;
  let maxDistance = 0;
  let maxRow = 0;
  let yardageSignsWrapper;
  if (greenDotsWrapper) {
    greenDotsWrapper.remove();
  }
  if (greenCurvesWrapper) {
    greenCurvesWrapper.remove();
  }
  if (data?.length === 0) {
    return;
  }
  d3.selectAll("#green").html("");
  maxRow = data?.map(function(row) {
    if (currClub === "Putter") {
      return Math.max(row?.totaldistance);
    }
    // return Math.max(row[carryOrTotal]);
    return row[carryOrTotal] ? Math.max(row[carryOrTotal]) : 0
  });
  maxDistance = Math.max.apply(null, maxRow) ?? 0;
  greenWidth = d3
    ?.select("#green")
    ?.node()
    ?.getBoundingClientRect().width;
  greenHeight = d3
    ?.select("#green")
    ?.node()
    ?.getBoundingClientRect().height;
  heightAdj = greenHeight / (maxDistance * 1.2);
  greenSvg = d3
    ?.select("#green")
    ?.html("")
    ?.append("svg")
    ?.attr("width", greenWidth)
    ?.attr("height", greenHeight);
  arc = d3.arc();
  halfcircle = function(x, y, rad, color) {
    return greenSvg
      ?.append("path")
      ?.attr("class", "arc")
      ?.style("fill", color)
      ?.attr("transform", `translate(${[x, y]})`)
      ?.attr(
        "d",
        arc({
          innerRadius: 0,
          outerRadius: rad,
          startAngle: -Math.PI * 0.5,
          endAngle: Math.PI * 0.5
        })
      );
  };
  switch (true) {
    case maxDistance > 200:
      distanceArr = [50, 100, 150, 200, 250, 300, 350, 400];
      break;
    case maxDistance > 100:
      distanceArr = [25, 50, 75, 100, 125, 150, 175, 200, 225];
      break;
    case maxDistance > 50:
      distanceArr = [10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 110];
      break;
    default:
      distanceArr = [5, 10, 15, 20, 25, 30, 35, 40, 45, 50];
  }
  arcColorArray = ["#888", "#777", "#666", "#555", "#444", "#333", "#222"];
  arcColorArrayIndex = 0;
  distanceArr?.reverse()?.forEach(function(val, i) {
    if (!(val * heightAdj > greenHeight)) {
      halfcircle(
        greenWidth / 2,
        greenHeight,
        val * heightAdj,
        arcColorArray[arcColorArrayIndex]
      );
      return arcColorArrayIndex++;
    }
  });
  greenSvg
    ?.append("line")
    ?.attr("x1", greenWidth / 2)
    ?.attr("y1", greenHeight)
    ?.attr("x2", greenWidth / 2)
    ?.attr("y2", 0)
    ?.attr("class", "centerline");
  greenCurvesWrapper = greenSvg?.append("g");
  data?.forEach(function(row, i) {
    let HLA;
    let adjDist;
    let apexX;
    let apexY;
    let curveAmt;
    let dist;
    let offline;
    let spinAxis;
    let startX;
    let startY;
    let x1;
    let x2;
    let xPos;
    let y1;
    let y2;
    let yPos;
    dist = row?.clubTypeKey === "Putter" ? row?.totaldistance : row[carryOrTotal] ? row[carryOrTotal] : 0;
    x1 = row?.startX;
    y1 = row?.startY;
    if (carryOrTotal === "distance" && row.clubTypeKey !== "Putter") {
      x2 = row?.carryX;
      y2 = row?.carryY;
    } else {
      x2 = row?.totalX;
      y2 = row?.totalY;
    }
    offline = getOffline(
      x1,
      y1,
      x2,
      y2,
      row.aimHeading,
      dist,
      row.hla,
      heightAdj
    );
    HLA = parseFloat(row.hla);
    spinAxis = row?.spinaxis;
    adjDist = Math.sqrt(
      Math.pow(dist * heightAdj, 2) - Math.pow(Math.abs(offline), 2)
    );
    xPos = Math.round(
      Math.max(0, Math.min(greenWidth, greenWidth / 2 + offline))
    );
    yPos = Math.round(greenHeight - adjDist);
    startX = greenWidth / 2;
    startY = greenHeight;
    if (row.clubTypeKey === "Putter") {
      curveAmt = 0;
    } else {
      curveAmt = (-spinAxis * dist) / 300;
    }
    apexX = (startX + xPos) / 2 + curveAmt;
    apexY = greenHeight - (greenHeight - (greenHeight - adjDist)) / 2;
    return greenCurvesWrapper
      ?.append("svg:path")
      ?.attr("d", `M${startX} ${startY}Q${apexX} ${apexY} ${xPos} ${yPos}`)
      ?.attr("class", `curve s${row?.id}${row?.compare === true ? " comp" : ""}`)
      ?.attr("id", `c-${i}`);
  });

  //* /* looping through them separately so dots will all overlay curves */
  greenDotsWrapper = greenSvg?.append("g");
  data?.forEach(function(row, i) {
    let HLA;
    let VLA;
    let adjDist;
    let backspin;
    let dist;
    let offline;
    let x1;
    let x2;
    let xPos;
    let y1;
    let y2;
    let yPos;
    dist = row?.clubTypeKey === "Putter" ? row?.totaldistance : row[carryOrTotal] ? row[carryOrTotal] : 0;
    x1 = row?.startX;
    y1 = row?.startY;
    if (carryOrTotal === "distance" && row.clubTypeKey !== "Putter") {
      x2 = row?.carryX;
      y2 = row?.carryY;
    } else {
      x2 = row?.totalX;
      y2 = row?.totalY;
    }
    offline = getOffline(
      x1,
      y1,
      x2,
      y2,
      row.aimHeading,
      dist,
      row.hla,
      heightAdj
    );
    HLA = parseFloat(row?.hla);
    VLA = parseFloat(row?.vla);
    backspin = Math.round(parseInt(row?.backspin));
    adjDist = Math.sqrt(
      Math.pow(dist * heightAdj, 2) - Math.pow(Math.abs(offline), 2)
    );
    xPos = Math.round(
      Math.max(0, Math.min(greenWidth, greenWidth / 2 + offline))
    );
    yPos = Math.round(greenHeight - adjDist);
    return greenDotsWrapper
      ?.append("circle")
      ?.attr("class", `top-dot s${row?.id}${row?.compare === true ? " comp" : ""}`)
      ?.attr("r", 5)
      ?.attr("cx", xPos)
      ?.attr("cy", yPos)
      ?.on("mouseover", function(d) {
        let leftPos;
        d3.selectAll(`.s${row?.id}`).classed("hover", true);
        bringToTop(d3.select(`s${row?.id}`));
        return (leftPos = xPos <= greenWidth / 2 ? xPos : xPos - 134);
      })
      ?.on("mouseout", function() {
        d3.selectAll(`.s${row.id}`).classed("hover", false);
        return sendToBack(d3.select(`.s${row.id}`));
      })
      ?.on("click", function() {
        return showShotDetail(row);
      });
  });
  yardageSignsWrapper = greenSvg?.append("g");
  return distanceArr?.forEach(function(val, i) {
    if (!(val * heightAdj - 50 * heightAdj > maxDistance * heightAdj)) {
      return yardageSignsWrapper
        ?.append("text")
        ?.attr("class", "yardage-sign")
        ?.attr("x", greenWidth / 2 + 4)
        ?.attr("y", greenHeight - val * heightAdj - 2)
        ?.html(val);
    }
  });
};

getOffline = (x1, y1, x2, y2, aimHeading, distance, hla, heightAdj) => {
  let angleDiff;
  let offline;
  let shotHead;
  shotHead = AA?.shotHeading(x1, y1, x2, y2);
  angleDiff = AA?.aimVsShotHeadingDiff(aimHeading, shotHead);
  offline =
    distance * Math.sin(angleDiff * (Math.PI / 180)) * 3 * (heightAdj / 3);
  return offline;
};

AA.shotHeading = function(x1, y1, x2, y2) {
  let theta;
  if (x1 === x2 && y2 > y1) {
    return 360;
  }
  if (y1 === y2 && x1 < x2) {
    return 90;
  }
  if (y1 === y2 && x1 > x2) {
    return 270;
  }
  if (x1 === x2 && y2 < y1) {
    return 180;
  }
  if (x1 === x2 && y1 === y2) {
    return 0;
  }

  theta = Math.atan2(x2 - x1, y2 - y1);
  if (theta < 0) {
    theta += 2 * Math.PI;
  }
  return theta * (180 / Math.PI);
};

AA.aimVsShotHeadingDiff = (a, b) => {
  let diff;
  let r;
  let sign;
  diff = Math.abs(a - b) % 360;
  r = diff > 180 ? 360 - diff : diff;
  sign =
    (a - b >= 0 && a - b <= 180) || (a - b <= -180 && a - b >= -360) ? -1 : 1;
  return (r *= sign);
};

export { loadInit as default };
